import { Plan } from '../model/plan';
import { ApiCrud } from './api-crud';
import http from './http';

const plans = new ApiCrud(http.AXIOS, Plan, 'plans');

plans.add({
  changeProductCategoryAllocation: 'PUT plans/:id/changeProductCategoryAllocation', // body: {productCategoryId, percentage}
  changeProductTypeAllocation: 'PUT plans/:id/changeProductTypeAllocation', // body: {productCategoryId, productTypeId, percentage}
  changeDisplayDeviceAllocation: 'PUT plans/:id/changeDisplayDeviceAllocation', // body: {productCategoryId, displayType, percentage}
  changeTargetingLevel: 'PUT plans/:id/changeTargetingLevel', // body: {productTypeId, level, fixCpm}
  updateFlag: 'PUT plans/:id/updateFlag',
  sendEmailNotification: 'POST plans/:id/sendEmailNotification',
  changeAppliedEmailNotification: 'POST plans/:id/changeAppliedEmailNotification',
  sendSubmitOrderNotification: 'POST plans/:id/sendSubmitOrderNotification',
  updateStatusEmailNotification: 'POST plans/:id/updateStatusEmailNotification',
  workflowEmailNotification: 'POST plans/:id/workflowEmailNotification',

  // create an order from a plan built using PlanBuilder tool
  createOrder: 'POST plans/:id/createOrder',

  // Export order - send an email w/ file attachments
  // Params:
  //   emailIds - list of email addresses as CSV string
  //   notes - text
  //  scheduledTime - Calendar DateTime [optional]
  export: 'POST plans/:id/export',
  submit: 'PUT plans/:id/submit',
});

export default plans;
